/**
 * Checks whether a cover art URL is known-bad and should not be rendered.
 * Conservative: only rejects known-bad patterns. If in doubt, show the image.
 */
export function isBadCoverUrlWithReason(url: string | null | undefined): { bad: boolean; reason?: string } {
  if (url === null || url === undefined) return { bad: true, reason: 'null/undefined' };
  const s = String(url).trim();
  if (s === '') return { bad: true, reason: 'empty string' };
  if (s.includes('coverartarchive.org/release-group/')) return { bad: true, reason: 'coverartarchive.org/release-group/ redirect URL' };
  if (s.startsWith('/') && !s.startsWith('//')) return { bad: true, reason: 'filesystem path, not a URL' };
  if (/^[A-Z]:\\/i.test(s)) return { bad: true, reason: 'Windows filesystem path' };
  if (s.startsWith('\\\\')) return { bad: true, reason: 'UNC path' };
  if (/^[0-9a-f]{64}$/i.test(s)) return { bad: true, reason: 'artwork hash, not a URL' };
  return { bad: false };
}

export function isBadCoverUrl(url: string | null | undefined): boolean {
  return isBadCoverUrlWithReason(url).bad;
}
